import { render, staticRenderFns } from "./NewPostbackTemplate.vue?vue&type=template&id=c099d840&scoped=true&"
import script from "./NewPostbackTemplate.vue?vue&type=script&lang=js&"
export * from "./NewPostbackTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewPostbackTemplate.vue?vue&type=style&index=0&id=c099d840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c099d840",
  null
  
)

export default component.exports